import { HTMLContent } from '../Content'

import { faWatch } from '@fortawesome/pro-regular-svg-icons'
import { faCaretRight } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

import { Button } from '../Button'
import { Link } from '../Link'

import './styles.css'

export const BlogPostPage = ({ content, title, subtitle }: any) => {
  return (
    <div>
      <div className="layout-body">
        <div className="grid mt-5 mb-3">
          <div className="col">
            <div>
              <h1 className="text-center">{title}</h1>
            </div>
            <div>
              <h4 className="text-center">{subtitle}</h4>
            </div>
          </div>
        </div>
        <div className="blog-post">
          <HTMLContent content={content} />
        </div>

        <div className="grid-12-center">
          <div className="hr mb-4 xs-mb-4 mt-6 xs-mt-4" />
        </div>

        <div className="grid-center">
          <div className="col-12 mb-2">
            <h1 className="text-center">Ready to go?</h1>
          </div>
        </div>

        <div className="mb-0-5 text-center">
          <Link to="/calculator">
            <Button
              theme="green"
              subText={
                <span>
                  <FontAwesomeIcon icon={faWatch} className="mr-0-5" />
                  Find out in 2 minutes
                  <FontAwesomeIcon icon={faCaretRight} className="ml-0-5" />
                </span>
              }
            >
              How much can I afford?
            </Button>
          </Link>
        </div>
        <div className="text-center">
          <Link to="/refinance-mortgage-calculator">
            <Button theme="text">
              Or refinance your existing home
              <FontAwesomeIcon icon={faCaretRight} className="ml-0-5" />
            </Button>
          </Link>
        </div>
      </div>
    </div>
  )
}
